import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import Select from 'components/Selectors/Select/mobile';
import SVG from 'components/SVG';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/view/desktop';
import Input from 'components/Input';

import approveSVG from 'shared/img/approve.svg';
import declineSVG from 'shared/img/decline.svg';

import PercentInfo from './PercentInfo';
import './Table.scss';

const b = block('player-deposits-table-desktop');

const Table = ({ model }) => {
  const locale = useSelector(s => s.locale.locale);

  const { state, handlers, out } = model;

  const items = out.items.map(item => (
    <div className={b('row')} key={item.id}>
      <div className={b('row-item', { type: 'date' })}>
        {dayjs(item.createdAt).add(-3, 'hour').format('HH:mm     DD.MM.YYYY')}
      </div>
      <div className={b('row-item')}>{item.id}</div>
      <div className={b('row-item')}>{item.username}</div>
      <div className={b('row-item')}>{locale[item.type] ?? ''}</div>
      <div className={b('row-item')}>{Object.keys(item.bank).length === 0 ? '' : item.bank.bank}</div>
      <div className={b('row-item')}>{item.cbu}</div>
      <div className={b('row-item', { withIcon: !!item.promoCodePercent })}>
        {item.amount}
        <PercentInfo percent={item.promoCodePercent} />
      </div>
      <div className={b('row-item')}>{item.name}</div>
      <div className={b('row-item')}>
        <div className={b('row-input')}>
          <Input
            placeholder="%"
            validState={state.bonusAmount && 4}
            onChange={e => handlers.handleBonusAmountChange(e, item)}
            value={state.bonusAmount}
            name="amount"
            withFormatting
            isBonus
            bonusPlaceholder="%"
            disabled={item.type !== 'deposit'}
            isMobile
            inTable
          />
        </div>
      </div>
      <div className={b('row-item', { type: 'buttons' })}>
        <SVG
          className={b('row-icon')}
          svgProps={{ svg: approveSVG }}
          onClick={() => handlers.handleRequestChange(item, 1)}
        />
        <SVG
          className={b('row-icon')}
          svgProps={{ svg: declineSVG }}
          onClick={() => handlers.handleRequestChange(item, 0)}
        />
      </div>
    </div>
  ));

  const headers = [
    locale.date,
    locale.id,
    locale.username,
    locale.operation,
    locale.bank,
    locale.details,
    locale.amount,
    locale.nameUsers,
    locale.bonus,
    locale.action,
  ].map((v, index) =>
    Array.isArray(v) ? (
      <div className={b('row-item')} key={index}>
        {v.map((item, subIndex) => (
          <span className={b('row-sub-item')} key={subIndex}>
            {item}
          </span>
        ))}
      </div>
    ) : (
      <div className={b('row-item')} key={index}>
        {v}
      </div>
    ),
  );

  return (
    <div className={b()}>
      <div className={b('header')}>
        <h2 className={b('header-title')}>{locale.result}</h2>
        <h2 className={b('header-text')}>{locale.elementsOnPage}</h2>
        <div className={b('header-select')}>
          <Select
            items={state.values.itemsOnPage}
            onChange={v => handlers.handleValueChange('itemsOnPage', v)}
            color="grey"
          />
        </div>
      </div>
      <div className={b('content')}>
        <div className={b('row', { type: 'header' })}>{headers}</div>
        {!!items.length ? items : <div className={b('no-results')}>{locale.noResults}</div>}
        <div className={b('pagination')}>
          <div>{`${out.count} ${locale.records}`}</div>
          <PaginatorSwitcher
            onPageClick={v => handlers.handleValueChange('page', v)}
            count={out.count}
            currentPage={state.values.page}
            itemsOnPage={out.activeItemsOnPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Table;
